import { useState } from "react";
import { api } from "../api";
import { useAuth } from "../AuthContext";

export default function CambioPasswordObbligatorio() {
  const { utente, logout } = useAuth();
  const [vecchia, setVecchia] = useState("");
  const [nuova, setNuova]     = useState("");
  const [conferma, setConferma] = useState("");
  const [errore, setErrore]   = useState(null);
  const [loading, setLoading] = useState(false);

  const salva = async () => {
    if (nuova !== conferma)
      return setErrore("Le password non coincidono");
    if (nuova.length < 8)
      return setErrore("La password deve essere di almeno 8 caratteri");

    setLoading(true); setErrore(null);
    try {
      await api.changePassword(vecchia, nuova);
      // Ricarica la pagina per aggiornare lo stato
      window.location.reload();
    } catch (e) {
      setErrore(e.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">🔑</div>
        <h1 className="login-title">Imposta la tua password</h1>
        <p className="login-sub">
          Benvenuto {utente?.nome}! Per la tua sicurezza devi impostare una nuova password prima di continuare.
        </p>

        {errore && <div className="errore-box" style={{ marginBottom: 16 }}>⚠️ {errore}</div>}

        <div className="form-group" style={{ marginBottom: 14 }}>
          <label className="form-label">Password attuale (temporanea)</label>
          <input className="form-input" type="password" value={vecchia}
            onChange={e => setVecchia(e.target.value)} placeholder="La password ricevuta" autoFocus />
        </div>
        <div className="form-group" style={{ marginBottom: 14 }}>
          <label className="form-label">Nuova password</label>
          <input className="form-input" type="password" value={nuova}
            onChange={e => setNuova(e.target.value)} placeholder="Minimo 8 caratteri" />
        </div>
        <div className="form-group" style={{ marginBottom: 20 }}>
          <label className="form-label">Conferma nuova password</label>
          <input className="form-input" type="password" value={conferma}
            onChange={e => setConferma(e.target.value)} placeholder="Ripeti la password" />
        </div>

        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}
          onClick={salva} disabled={loading || !vecchia || !nuova || !conferma}>
          {loading ? "Salvataggio..." : "Imposta password e accedi"}
        </button>

        <button onClick={logout} style={{ display: "block", width: "100%", marginTop: 12, background: "none", border: "none", color: "#94a3b8", fontSize: 12, cursor: "pointer" }}>
          Esci
        </button>
      </div>
    </div>
  );
}
